<template>
  <main>
    <v-row>
      <v-col>
        <v-btn @click="onNewItem(null)" title="Aggiungi Macro Tag">
          <v-icon>mdi-folder-plus</v-icon>
        </v-btn>
        <v-treeview
          :items="tags"
          dense
          hoverable
          :return-object="true"
          transition
        >
          <template v-slot:label="{ item }">
            <div>{{ item.descrizione }}</div>
          </template>
          <template v-slot:append="{ item }">
            <v-btn icon @click.stop="openEditDialog(item)" title="Modifica l'elemento">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click.stop="openDeleteDialog(item)" title="Cancella l'elemento">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
            <v-btn icon @click.stop="onNewItem(item, true)" title="Aggiungi prodotto">
              <v-icon small>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-treeview>

        <v-btn @click="saveTags">salva modifiche</v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Crea Nuovo Tag</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="newTag.descrizione" label="Descrizione"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="newTag.codice" label="Codice"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="saveNewTag">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Modifica Tag</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="editedTag.descrizione" label="Descrizione"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editedTag.codice" label="Codice"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeEditDialog">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="saveEditedTag">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Sei sicuro?</v-card-title>
        <v-card-text>
          Vuoi davvero eliminare questo elemento?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">Annulla</v-btn>
          <v-btn color="red darken-1" text @click="confirmDelete">Elimina</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
/* eslint-disable */
import configurazioni from '@/services/configurazioniService.js';

export default {
  data() {
    return {
      tags: [],
      dialog: false,
      editDialog: false,
      deleteDialog: false,
      newTag: { descrizione: '', codice: '' },
      editedTag: {},
      parent: null,
      itemToDelete: null,
      itemToEdit: null,
    };
  },
  async mounted() {
    this.dialog = false;
    const tags = await configurazioni.getConfigurazione("ristorazione", 'tags');
    if (tags) this.tags = tags;
    this.renameProps('tags', 'children');
  },
  methods: {
    saveTags() {
      this.renameProps('children', 'tags');
      configurazioni.modificaConfigurazione({ _id: 'ristorazione', tags: this.tags });
    },
    openDeleteDialog(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    onNewItem(item = null) {
      this.dialog = true;
      this.parent = item;
    },
    confirmDelete() {
  if (this.itemToDelete) {
    this.tags = this.removeTagByPath(this.itemToDelete.path, this.tags);
    this.recalculatePaths();
  }
  this.deleteDialog = false;
  this.itemToDelete = null;
},
removeTagByPath(path, tagList) {
  if (path.length === 1) {
    tagList.splice(path[0], 1);
  } else {
    let parentPath = path.slice(0, -1);
    let indexToRemove = path[path.length - 1];
    let parent = this.findTagByPath(parentPath, tagList);
    if (parent) {
      parent.splice(indexToRemove, 1);
    }
  }
  return JSON.parse(JSON.stringify(tagList));
},
    recalculatePaths() {
      const assignPath = (node, currentPath = []) => {
        node.path = [...currentPath]; // Assign the correct path
        if (node.children) {
          node.children.forEach((child, index) => {
            assignPath(child, [...currentPath, index]);
          });
        }
      };

      this.tags.forEach((tag, index) => assignPath(tag, [index])); // Start from the root
    },
    findTagByPath(path, tagList) {
      let current = tagList;
      for (let i = 0; i < path.length; i++) {
        if (!current[path[i]]) return null;
        current = current[path[i]].children;
      }
      return current;
    },
    openEditDialog(item) {
      this.itemToEdit = item;
      this.editedTag = { ...item };
      this.editDialog = true;
    },
    saveEditedTag() {
      Object.assign(this.itemToEdit, this.editedTag);
      this.editDialog = false;
    },
    onNewItem(item, expanded) {
      this.dialog = true;
      this.parent = item;
    },
    renameProps(oldName, newName) {
      function dfs(tag) {
        tag[newName] = tag[oldName];
        delete tag[oldName];
        (tag[newName] || []).forEach(dfs);
      }
      (this.tags || []).forEach(dfs);
    },
    closeDialog() {
      this.dialog = false;
      this.newTag = { descrizione: '', codice: '' };
    },
    closeEditDialog() {
      this.editDialog = false;
      this.editedTag = {};
    },
    saveNewTag() {
    const newTag = {
      descrizione: this.newTag.descrizione,
      codice: this.newTag.codice,
      children: []
    };

    if (this.parent) {
      let current = this.tags[this.parent.path[0]];
      for (let i = 1; i < this.parent.path.length; i++) {
        current = current.children[this.parent.path[i]];
      }
      if (!current.children) current.children = [];
      newTag.path = [...current.path, current.children.length];
      current.children.push(newTag);
    } else {
      newTag.path = [this.tags.length]
      this.tags.push(newTag);
    }
    this.tags = JSON.parse(JSON.stringify(this.tags));

    this.closeDialog();
}

  }
};
</script>
